// @generated
// This file is automatically generated by Kanel. Do not modify manually.
import { z } from 'zod';
/** Represents the enum public.inv_product_status_enum */
var InvProductStatusEnum;
(function (InvProductStatusEnum) {
    InvProductStatusEnum["PENDING"] = "PENDING";
    InvProductStatusEnum["APPROVED"] = "APPROVED";
    InvProductStatusEnum["REJECTED"] = "REJECTED";
})(InvProductStatusEnum || (InvProductStatusEnum = {}));
;
export default InvProductStatusEnum;
/** Zod schema for inv_product_status_enum */
export const invProductStatusEnum = z.nativeEnum(InvProductStatusEnum);
//# sourceMappingURL=InvProductStatusEnum.js.map